import React, { useMemo } from 'react';
import { useTheme } from 'styled-components';

import { Text } from 'src/packages/core';
import { getNotificationStyles, StyledNotification } from './Notification.styles';
import { InfoIcon, CheckCircleIcon } from 'src/packages/icons';
import { NotificationProps } from './Notification.types';

const Notification: React.FC<NotificationProps> = (props: NotificationProps) => {
  const theme = useTheme();
  const {
    type = 'success',
    width = 'fit-content',
    text = 'Notification text',
    withBorder = false,
    customContent = undefined,
    ...rest
  } = props;

  const notificationStyles = useMemo(() => {
    return getNotificationStyles(type, theme, withBorder);
  }, [type, theme, withBorder]);

  const notificationIcon = useMemo(() => {
    switch (type) {
      case 'error':
        return <InfoIcon />;
      case 'success':
        return <CheckCircleIcon />;
      case 'warning':
        return <InfoIcon />;
      case 'info':
        return <InfoIcon />;
    }
  }, [type]);

  return (
    <StyledNotification notificationStyles={notificationStyles} width={width} {...rest}>
      {customContent ?? (
        <>
          {notificationIcon}
          <Text variant='p2' text={text} color={'currentColor'} />
        </>
      )}
    </StyledNotification>
  );
};

export default Notification;
